// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"4ce7a4de","453":"20359781","511":"f19bc166"}[chunkId] + ".chunk.js";
};